function thousandsSeparator(val: number) {
  return val
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export const YeastVolumeItem = ({ volume, unit }: { volume?: number; unit: string }) => {
  return (
    <span className="flex-1">
      {volume ? thousandsSeparator(volume) : '--'} {unit}
    </span>
  );
};
